<template>
  <div class="container-fluid m-0 p-0">
    <div class="row text-left bg-light border-bottom py-3 d-flex justify-content-between">
      <div class="col-auto">
        <h5 class="mb-0 font-weight-bold">Cabin Monitoring</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack"
        >
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-12 text-center d-flex justify-content-end align-items-center">
        <button id="generateReport" class="btn btn-primary btn-xs p-1 d-flex align-items-center"
                :disabled="loadingPdf"
          @click="generateReport"
        >
          <i class="fas fa-file-pdf fa-2x mx-1"></i>
          Generate Report
        </button>
      </div>
      <div class="col col-12">
        <table class="table table-hover table-bordered table-template-1 text-small table-striped my-2 sticky-header">
          <thead>
          <tr>
<!--            <th width="1">No</th>-->
            <th style="width: 20em">Name</th>
            <th style="width: 10em">Max Capacity</th>
            <th style="width: 10em">No. of Cabins</th>
            <th style="width: 10em">No. of Crews O/B</th>
            <th style="width: 10em">Cabin Remains Except for Pilot</th>
          </tr>
          </thead>

          <tbody class="text-small">
          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>
          <template v-else>
            <template v-if="vesselList">
              <tr :key="vessel.name" v-for="(vessel) in vesselList">
<!--                <td class="text-center">{{index + 1}}</td>-->
                <td>{{vessel.vessel}}</td>
                <td class="text-center">{{vessel.maxCapacity}}</td>
                <td class="text-center">{{vessel.noOfCabins}}</td>
                <td class="text-center">{{vessel.onboardCrewCount}}</td>
                <td class="text-center">{{vessel.cabRemaining}}</td>
              </tr>
            </template>

          </template>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {vueAppMixin} from "../../../../mixins/vueAppMixin";
import AppLoading from "../../../elements/AppLoading.vue";
import {ReportService} from "../../../../services/ReportService";
import {FileService} from "../../../../services/FileService";

export default {
  name: "GenerateCabinMonitoring",
  components: {AppLoading},
  mixins: [vueAppMixin],
  data(){
    return{
      vesselList:[],
      loadingPdf:false,
    }
  },
  async created() {
    this.$store.commit('SET_IS_LOADING',true)
    this.loadingPdf=true
    const response = await ReportService.generateCabinMonitoring();
    if(response.status == 200){
      this.vesselList= response?.data ?? []
    }
    this.loadingPdf=false
    this.$store.commit('SET_IS_LOADING',false)
  },
  methods:{
    async generateReport(){
      swal.fire({
        'title' : 'GENERATING REPORT..'
      })
      swal.showLoading()
      const timeStamp=Date.now()
      this.loadingPdf=true
      const response = await ReportService.generateCabinMonitoring({print:true});
      if(response.status==200){
        FileService.downloadDocument(response,`CABIN-MONITORING-${timeStamp}.pdf`)
      }
      swal.close()
      this.loadingPdf=false;
    }
  }
}
</script>

<style scoped>

</style>